import axios from "axios";
import constant from "../../constant";

export const getAmenitiesList = () => {
  return (dispatch, getState) => {
    // make async call to database
    axios
      .get(`${constant.phpHost}action/newspace.php`, {
        params: {
          todo: "get_amenities_list"
        }
      })
      .then(res => {
        let amenities = res.data;
        dispatch({ type: "GET_AMENITIES", amenities });
      });
  };
};
